<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          id="email"
          :error="$store.state.error.state('email')"
          :error-messages="$store.state.error.get('email')"
          name="email"
          type="email"
          :label="$t('Your email')"
          :value="$store.state.email"
          @change="onChange({ email: $event })"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          id="tel"
          :error="$store.state.error.state('tel')"
          :error-messages="$store.state.error.get('tel')"
          name="tel"
          type="tel"
          :label="$t('Your phone')"
          :value="$store.state.tel"
          @change="onChange({ tel: $event })"
        />
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import updateRouteQuery from "@/actions/updateRouteQuery";

export default {
  methods: {
    onChange(updatables) {
      this.$store.commit("SET", updatables);
      updateRouteQuery(this.$route, updatables);
    },
    syncFromQueryParams() {
      const updatables = {
        email: this.$route.query.email,
        tel: this.$route.query.tel,
      };

      this.$store.commit("SET", updatables);
    },
  },
};
</script>
